import { useState, useEffect } from "react";
import axios from "axios";
import { useAccount } from "@azure/msal-react";
import { InteractionRequiredAuthError } from "@azure/msal-browser";
import { useMsal } from "@azure/msal-react";

import { protectedResources } from "../authConfig";

// Generic function that fetches data from the api. Uses axios.
// It is preceeded with a request for a new access token from the ADB2C client for every call. 
const useApiGetWithToken = (url) => {
  const { instance, accounts, inProgress } = useMsal();
  const [data, setData] = useState([]);
  const [isLoaded, setIsLoaded] = useState(false);
  const [error, setError] = useState(null);
  const account = useAccount(accounts[0] || {});
  const [fetchFlag, setFetchFlag] = useState(0);

  useEffect(() => {
    if (account && inProgress === "none") {
        instance.acquireTokenSilent({
            scopes: protectedResources.api.scopes,
            account: account
        }).then((response) => {
            fetchData(response.accessToken,url);
        })
        .catch((error) => {
            // in case if silent token acquisition fails, fallback to an interactive method
            if (error instanceof InteractionRequiredAuthError) {
                if (account && inProgress === "none") {
                    instance.acquireTokenRedirect({
                        scopes: protectedResources.api.scopes,
                    }).then((response) => {
                        fetchData();
                    }).catch(error => console.log(error));
                }
            }
        });
    }
  }, [fetchFlag]);

    const fetchData = (token,url) => {
        axios
        .get(url, {
            headers: {
                'Authorization': 'Bearer ' + token
            }
            })
        .then(response => {
            setIsLoaded(true);
            setData(response.data);
        })
        .catch(error => {
            setError(error);
        });
    };

    function triggerFetch() {
        // Set fetchFlag to indirectly trigger the useEffect above
        setData([]);
        setIsLoaded(false);
        setError(null);
        setFetchFlag(Math.random());
      }    

  return { error, isLoaded, data, triggerFetch };
};
  
export default useApiGetWithToken;